import React from 'react';
import './Chaperone.css';

const Chaperone = () => {
  return (
    <main className="chaperone-page">
      <div className="chaperone-container">
        <section className="chaperone-hero">
          <h1 className="chaperone-title">Youth Supporting Roots</h1>
          <p className="chaperone-subtitle">Generations Working Together</p>
          <h2 className="opportunity-title">Summer Chaperone Opportunity</h2>
        </section>
        
        <section className="chaperone-content">
          <div className="application-section">
            <p className="application-text">
              <a href="https://forms.gle/fYeirMKm7ZXCSDQw8" target="_blank" rel="noopener noreferrer" className="online-application-link">
                Click here to go to the online application.
              </a>
            </p>
            
            <p className="download-text">
              Or Click here to <a href="https://drive.google.com/file/d/1idayNs6AehzTz4urifej9QwtoS6LSWG8/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="download-link">download</a> and print an application to mail in.
            </p>
          </div>

          <div className="opportunity-description">
            <p className="intro-text">
              Ready to earn some extra cash ($11 per hour) while giving back to the community and supporting the next generation? Join our team!
            </p>
          </div>

          <div className="role-details">
            <ul className="role-list">
              <li>Your service will take place over 8 weeks of summer, at local food pantries.</li>
              <li>You'll be responsible for chaperoning one or two teen interns (14 – 16 years old) for a maximum of 24 hours per week.</li>
              <li>The weekly schedule will run from Sunday to Saturday, with two days off.</li>
              <li>You'll receive compensation at a fixed rate of <strong>$11.00 per hour</strong>, paid out in two installments. The first payment will be at the end of four weeks, and the second will be at the end of the full eight weeks, both on Thursdays.</li>
            </ul>
          </div>

          <div className="duties-section">
            <h3 className="duties-title">Daily duties and expectations for your role:</h3>
            
            <ul className="duties-list">
              <li>Be punctual</li>
              <li>Let YSR administration know right away if any issues come up</li>
              <li>Dress in closed-toed shoes, YSR tee shirt, knee-length skirt or slacks</li>
              <li>Be responsible for a YSR phone, making sure it is on vibrate during work hours</li>
              <li>Meet your intern(s) before entering site</li>
              <li>Keep your intern(s) in view at all times</li>
              <li>Greet site staff</li>
              <li>Follow site manager's assignments and instructions</li>
              <li>Ensure that your intern understands their assignment</li>
              <li>Give intern a brief note of positive feedback</li>
              <li>Get feedback from site manager</li>
              <li><strong>(Weekly)</strong> Give a brief written descriptive note with picture included</li>
            </ul>
          </div>

          <div className="application-footer">
            <p className="footer-text">
              If you are interested in this summer opportunity, please{' '}
              <a href="https://forms.gle/fYeirMKm7ZXCSDQw8" target="_blank" rel="noopener noreferrer" className="footer-application-link">
                click here to fill out the online application.
              </a>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Chaperone;
